import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../../../../app/hooks';
import { fetchLatestConsents } from '../../../../store/dashboard/creditBureau/actions';

export interface ConsentInfo {
    consenterName: string;
    consentedAt: string;
}

interface UseLatestConsentsParams {
    orgId?: string;
}

interface UseLatestConsentsReturn {
    consentByDirectorId: Record<string, ConsentInfo>;
    isLatestConsentsLoaded: boolean;
}

function useLatestConsents({ orgId }: UseLatestConsentsParams): UseLatestConsentsReturn {
    const dispatch = useAppDispatch();
    const latestConsents = useAppSelector((state) => state.dashboard.creditBureau.latestConsents);
    const isLatestConsentsLoaded = useAppSelector((state) => state.dashboard.creditBureau.isLatestConsentsLoaded);

    useEffect(() => {
        if (!orgId) return;
        dispatch(fetchLatestConsents({ orgId }));
    }, [orgId]);

    return {
        consentByDirectorId: latestConsents || {},
        isLatestConsentsLoaded: !!isLatestConsentsLoaded,
    };
}

export default useLatestConsents;
